import { observable } from '@datagrid/state';

import type { AppConfig } from '@/core/types';

export const configStore = observable<AppConfig>({} as AppConfig);
